import { defaultIsometricGrid } from '@/core/grid';

/**
 * React hook that provides access to the IsometricGrid instance
 * Bridge between core grid logic and React components
 */
export const useGrid = () => {
    return defaultIsometricGrid;
};
